import FullScreenBackgroundGradient from "@/components/backgrounds/FullScreenBackgroundGradient"
import { Horizontal, Vertical } from "@/components/standard/BFLayout"

import Svg, { Path, type SvgProps } from "react-native-svg"
import { ScrollView, View } from "react-native"
import { HDisplay, TealText } from "@/components/standard/BFText"
import BackflipLogo from "@/assets/logo/backflip-logo.svg"
import { Image } from "expo-image"
import { BecomeMemberCTA } from "@/screens/prequal/components/BecomeMemberCTA"
import { PrimaryDarkButton } from "@/components/buttons/CommonButtons"
import { preQualLandingPageIntentClick } from "@/analytics/events/preQual"
import { router } from "expo-router"
import { DownloadAppBar } from "@/screens/prequal/components/DownloadAppBar"
import { PreQualContent } from "@/screens/prequal/components/PreQualContent"

function SquigglyLine(props: SvgProps) {
  return (
    <Svg
      width={448}
      height={1485}
      viewBox="0 0 448 1485"
      fill="none"
      {...props}
    >
      <Path
        d="M274.148 2c28 3 27.5 32.5 11.5 41.5s-34.879 11.937-67.337 8.163c-33.287-3.87-65.856-.728-98.899 3.535-25.355 3.272-51.382 15.42-72.19 29.772 0 0-52.073 38.53-44.462 99.999 7.611 61.468 83.738 93.636 83.738 93.636 34.528 15.579 71.271 24.892 108.561 31.107 21.17 3.528 42.123 8.079 63.314 11.311 22.843 3.485 46.944 5.365 68.892 12.805 37.739 12.793 70.801 45.237 86.958 81.224 8.091 18.021 11.925 38.448 12.726 57.973 1.049 39.899-24.347 125.875-134.326 150.586C187.597 618.723 103.148 696 111.148 762c8 66 113 78.5 158.5 83s191.5 33.5 175.5 224.5-372 162-392 293 163.667 124.67 216.5 124"
        stroke="#286588"
        strokeWidth={3}
        strokeLinecap="round"
      />
    </Svg>
  )
}

export const AnalyzerLandingScreen = () => {
  return (
    <Vertical className={" flex-1"}>
      <FullScreenBackgroundGradient preQual={true} />
      <ScrollView className={"flex-1 flex-col gap-5"}>
        <View className={"p-5"}>
          <BackflipLogo />
        </View>

        <PreQualContent>
          <View className={"absolute top-[155px] items-center  w-full"}>
            <SquigglyLine />
          </View>

          <BecomeMemberCTA />

          <View className={"gap-10 p-5"}>
            <Vertical>
              <HDisplay color={"white"} className={"z-20"}>
                Analyze{"\n"}
                <TealText>deals</TealText>
              </HDisplay>
              <Image
                style={{ width: 335, minHeight: 200, marginTop: -30 }}
                source={require("./components/analyze.png")}
                contentFit={"contain"}
              />
            </Vertical>

            <Vertical>
              <HDisplay color={"white"} className={"text-right"}>
                Customize{"\n"}
                <TealText>comps</TealText>
              </HDisplay>
              <Image
                style={{
                  alignSelf: "flex-start",
                  width: 265,
                  minHeight: 200,
                  marginTop: -4,
                  marginLeft: 10,
                }}
                source={require("./components/comps.png")}
                contentFit={"contain"}
              />
            </Vertical>

            <Horizontal className={"relative items-center "}>
              <Image
                style={{
                  alignSelf: "flex-end",
                  minWidth: 60,
                  minHeight: 200,
                  marginTop: 0,
                  flex: 1,
                }}
                source={require("./components/app.png")}
                contentFit={"contain"}
              />
              <HDisplay color={"white"} className={"text-right"}>
                Power{"\n"}
                <TealText>in your</TealText>
                {"\n"}
                <TealText>pocket</TealText>
              </HDisplay>
            </Horizontal>
          </View>
          <Vertical className={"p-5 gap-5 items-center"}>
            <View className={"w-[250px]"}>
              <PrimaryDarkButton
                size={"md"}
                title={"Unlock Access"}
                testID={"unlock-access-bottom"}
                onPress={() => {
                  preQualLandingPageIntentClick({
                    intent: "SignUp",
                    id: "unlock-access-bottom",
                    title: "Unlock Access",
                  })
                  router.push("/register")
                }}
              />
            </View>
          </Vertical>
        </PreQualContent>
      </ScrollView>
      <DownloadAppBar />
    </Vertical>
  )
}
